import { components } from 'type/ReportServiceSchema';
import {
  BenchmarkRelativeScoreModel,
  mapBenchmarkRelativeScoreDtoToModel,
} from 'api/dto/new/Common/BenchmarkRelativeScore.dto';
import { CategoryModel, mapCategoryDtoToModel } from 'api/dto/new/Common/Category.dto';
import {
  DetailWithTrendQuestionModel,
  mapDetailWithTrendQuestionDtoToModel,
} from 'api/dto/new/Common/DetailWithTrendQuestion.dto';
import {
  TrendRelativeScoreModel,
  mapTrendRelativeScoreDtoToModel,
} from 'api/dto/new/Common/TrendRelativeScore.dto';

export type CategoryItemDto = components['schemas']['CategoryItem'];

export type CategoryItemModel = {
  score?: number | null;
  benchmark: BenchmarkRelativeScoreModel;
  category: CategoryModel;
  confidentialityProtection: boolean;
  details: DetailWithTrendQuestionModel[];
  trends: TrendRelativeScoreModel[];
};

export const mapCategoryItemDtoToModel = (dto: CategoryItemDto): CategoryItemModel => ({
  score: dto.score,
  benchmark: mapBenchmarkRelativeScoreDtoToModel(dto.benchmark),
  category: mapCategoryDtoToModel(dto.category),
  confidentialityProtection: dto.confidentialityProtection,

  details: dto.details.map(mapDetailWithTrendQuestionDtoToModel),

  trends: dto.trends.map(mapTrendRelativeScoreDtoToModel),
});
